class VGCategoryPanel {
  constructor(panel) {
    this.panel = panel;
    this.details = panel.closest('details');
    this.headerMenu = panel.closest('header-menu');

    this.views = Array.from(
      panel.querySelectorAll('[data-vg-view]')
    );

    this.lastOpener = null;

    this.bindEvents();
  }

  bindEvents() {
    this.panel.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-vg-open-view]');

      if (openButton && this.panel.contains(openButton)) {
        event.preventDefault();

        const viewId = openButton.dataset.vgOpenView;

        this.lastOpener = openButton;

        this.showView(viewId, true);

        return;
      }

      const backButton = event.target.closest('[data-vg-back]');

      if (backButton && this.panel.contains(backButton)) {
        event.preventDefault();

        this.showView('root', false);

        if (this.lastOpener) {
          this.lastOpener.focus();
        }

        return;
      }

      const closeButton = event.target.closest('[data-vg-close]');

      if (closeButton && this.panel.contains(closeButton)) {
        event.preventDefault();

        this.closePanel();
      }
    });

    if (this.details) {
      this.details.addEventListener('toggle', () => {
        if (!this.details.open) {
          this.reset();
        }
      });
    }
  }

  showView(viewId, moveFocus = false) {
    let selectedView = null;

    this.views.forEach((view) => {
      const isSelected = view.dataset.vgView === viewId;

      view.hidden = !isSelected;

      if (isSelected) {
        selectedView = view;
      }
    });

    if (!selectedView) {
      return;
    }

    this.panel.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    if (moveFocus) {
      const backButton = selectedView.querySelector('[data-vg-back]');

      if (backButton) {
        window.requestAnimationFrame(() => {
          backButton.focus();
        });
      }
    }
  }

  closePanel() {
    if (this.headerMenu && typeof this.headerMenu.close === 'function') {
      this.headerMenu.close();
    } else if (this.details) {
      this.details.removeAttribute('open');
    }

    const summary = this.details?.querySelector('summary');

    if (summary) {
      summary.focus();
    }

    this.reset();
  }

  reset() {
    this.views.forEach((view) => {
      view.hidden = view.dataset.vgView !== 'root';
    });

    this.lastOpener = null;
  }
}

function initializeVGCategoryPanels() {
  const panels = document.querySelectorAll(
    '.vg-category-menu__panel'
  );

  panels.forEach((panel) => {
    if (panel.dataset.vgInitialized === 'true') {
      return;
    }

    panel.dataset.vgInitialized = 'true';

    new VGCategoryPanel(panel);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeVGCategoryPanels
  );
} else {
  initializeVGCategoryPanels();
}